import React, { useEffect } from 'react';
import { formatNumber } from "../config/AppConfig";

function PricingPlansComparison({ subscriptions, category }) {

    function formatPrice(price) {
        if (isNaN(price) || price === null || price === undefined) {
            return '0.00';
        }
        return parseFloat(price)
            .toLocaleString('fr-FR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })
            .replace(',', '.');
    }
  const filterSubscriptions = subscriptions.filter(sub => sub.category === category);

    const allOptions = Array.from(
        new Set(
            filterSubscriptions.flatMap(sub => sub.options.map(opt => opt.option))
        )
    );

    return (
        <section className="section-py pricing-plans-comparison">
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center mb-4">
                        <h2 className="mb-2">Choisissez le plan qui vous correspond le mieux</h2>
                        <p className="mb-1">Tableau de comparatif des fonctionnalités offertes par chaque plan</p>
                    </div>
                </div>
                <div className="row mx-4">
                    <div className="col-12">
                        <div className="table-responsive border rounded">
                            <table className="table table-striped text-center mb-0">
                                <thead>
                                <tr>
                                    <th scope="col">
                                        <p className="mb-1 text-start">Fonctionnalité</p>
                                    </th>
                                    {filterSubscriptions.map((subscription) => (
                                        <th key={subscription.id} scope="col">
                                            <p className="mb-1">{subscription.title}</p>
                                            <small className="text-black fw-normal text-capitalize">
                                                {`${formatPrice(subscription.price)} ${subscription.currency}/${subscription.periodicity.toLowerCase()}`}
                                            </small>
                                        </th>
                                    ))}
                                </tr>
                                </thead>
                                <tbody>
                                {allOptions.map((optionName, index) => (
                                    <tr key={index}>
                                        <td className="text-start">{optionName}</td>
                                        {filterSubscriptions.map((subscription) => {
                                            const option = subscription.options.find(opt => opt.option === optionName);
                                            return (
                                                <td key={subscription.id}>
                                                    {option ? option.value : "N/A"}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default PricingPlansComparison;
